import { Example } from './Example'
import { getExampleQuestions } from '../../api'
import { useEffect, useState } from 'react'

import styles from './Example.module.css'

interface Props {
    onExampleClicked: (value: string) => void
}

export const ExampleList = ({ onExampleClicked }: Props) => {
    const [examples, setExamples] = useState<string[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        const fetchExamples = async () => {
            try {
                setIsLoading(true)
                const token = undefined
                const questions = await getExampleQuestions(token)
                setExamples(questions.map((q) => q.question))
            } catch (error) {
                console.error('Failed to fetch example questions:', error)
                setExamples([
                    'Example question 1',
                    'Example question 2',
                    'Example question 3',
                ])
            } finally {
                setIsLoading(false)
            }
        }
        fetchExamples()
    }, [])

    return (
        <ul className={styles.examplesNavList}>
            {isLoading
                ? [1, 2, 3].map((i) => (
                      <li key={i}>
                          <Example
                              text=""
                              value=""
                              onClick={() => {}}
                              loading={isLoading}
                          />
                      </li>
                  ))
                : examples.slice(0, 3).map((question, i) => (
                      <li key={i}>
                          <Example
                              text={question}
                              value={question}
                              onClick={onExampleClicked}
                              loading={isLoading}
                          />
                      </li>
                  ))}
        </ul>
    )
}
